<!-- begin:: Header Topbar -->
<div class="kt-header__topbar">
    <!--begin: Search -->
    <!-- <kt-search-dropdown [icon]="'./assets/media/icons/svg/General/Search.svg'" [useSVG]="true"></kt-search-dropdown> -->
    <!--end: Search -->
    <!--begin: Notifications -->
    <kt-notification
        [dot]="dotAndPulseValue"
        [bgImage]="'./assets/media/misc/bg-1.jpg'"
        [pulse]="dotAndPulseValue"
        [skin]="'dark'"
        [icon]="'./assets/media/icons/svg/General/Notifications1.svg'"
        [useSVG]="true"
        [notifications]="notifications"
        (notificationSelect)="selectedNotificationChanged($event)"
    ></kt-notification>
    <!--end: Notifications -->
    <!--begin: Quick actions -->
    <!-- <kt-quick-action [bgImage]="'./assets/media/misc/bg-2.jpg'" [skin]="'dark'" [icon]="'./assets/media/icons/svg/Media/Equalizer.svg'" [useSVG]="true"></kt-quick-action> -->
    <!--end: Quick actions -->
    <!--begin: My Cart -->
    <!-- <kt-cart [bgImage]="'./assets/media/misc/bg-1.jpg'" [icon]="'./assets/media/icons/svg/Shopping/Cart3.svg'" [useSVG]="true"></kt-cart> -->
    <!--end: My Cart -->
    <!--begin: Quick panel toggler -->
    <!-- <div class="kt-header__topbar-item kt-header__topbar-item--quick-panel" data-placement="bottom" ngbTooltip="Quick panel">
        <span class="kt-header__topbar-icon" id="kt_quick_panel_toggler_btn">
            <span class="kt-svg-icon" [inlineSVG]="'./assets/media/icons/svg/Layout/Layout-4-blocks.svg'"></span>
        </span>
    </div> -->
    <!--end: Quick panel toggler -->
    <!--begin: Language bar -->
    <!-- <kt-language-selector></kt-language-selector> -->
    <!--end: Language bar -->
    <!--begin: User bar -->
    <kt-user-profile></kt-user-profile>
    <!--end: User bar -->
</div>
<!-- end:: Header Topbar -->
<p-dialog
    [modal]="true"
    position="top"
    [(visible)]="notificationDialog"
    [style]="{ width: '30vw' }"
    (onHide)="selectedNotification = null"
>
    <p-header>
        Bildirim Detayı
    </p-header>
    <p class="font-weight-bold">{{ selectedNotification?.title }}</p>
    <p class="text-justify mt-3" style="white-space: pre-wrap;">{{ selectedNotification?.detail }}</p>
    <div class="text-right mt-2">
        <small>{{ selectedNotification?.creationDate | date: 'dd.MM.yyyy HH:mm:ss' }}</small>
    </div>
    <p-footer>
        <button class="btn btn-secondary mr-1" type="button" (click)="notificationDialog = false">
            <i class="fa fa-times"></i> Kapat
        </button>
    </p-footer>
</p-dialog>
